import * as taskName from '../set-and-shop-scan/task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import * as processAction from '../../process-action'
import { selectTreatmentPlan } from '../../../../treatment/state/plan/selector'
import { selectProcessContext } from '../../../state/instance-detail/selector'

export default createUIDefinition({
    taskName: taskName.COMPLEXITY_TREATMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.COMPLEXITY_TREATMENT_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectTreatmentPlan,
        selectProcessContext,
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
    ],
    taskValidator: (task, processInstance, taskName, eventName, treatmentPlan, processContext) => {
        const messageList = []

        if (treatmentPlan === undefined && processContext.complexity === '') {
            messageList.push(createValidationMessage('Please choose a treatment complexity.', 'validateTreatmentPlanComplexity'))
        }
        if (treatmentPlan && !treatmentPlan.complexity) {
            messageList.push(createValidationMessage('Please choose a treatment complexity.', 'validateTreatmentPlanComplexity'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/treatment-plan-complexity-assignment.js